import type { ReactNode } from "react";
import React from "react";
import { accordionItem, accordionItemActive } from "./Accordion.css";
import type { AccordionItemContentProps } from "./AccordionItemContent";
import type { AccordionItemFooterProps } from "./AccordionItemFooter";
import type { AccordionItemLabelProps } from "./AccordionItemLabel";

export type AccordionItemProps = {
  value: string;
  selectedValue?: string | null;
  onChange?: (value: string) => void;
  children: ReactNode;
  expandAll?: boolean;
  radioName: string;
};
export type AccordionItemType = React.FC<AccordionItemProps> & {
  Content: React.FC<AccordionItemContentProps>;
  Footer: React.FC<AccordionItemFooterProps>;
  Label: React.FC<AccordionItemLabelProps>;
};

export const AccordionItem: React.FC<AccordionItemProps> = ({
  value,
  selectedValue,
  onChange,
  expandAll,
  children,
  radioName
}) => {
  const isSelected = selectedValue === value;
  const accordionItemClass = isSelected ? accordionItemActive : accordionItem;
  return (
    <div role="tab" className={accordionItemClass}>
      {React.Children.map(children, (child) => {
        if (!child) {
          return null;
        }
        return React.cloneElement(child as React.ReactElement, {
          value,
          selectedValue,
          onChange,
          expandAll,
          radioName
        });
      })}
    </div>
  );
};
